<template>
    <div class="shortmessageindex">
        <div class="top">
            <el-col :span="19">     
               <location-selector  @change="handleFilter()"  v-model="locationArray"></location-selector>
                <el-select size="medium" v-model="listQuery.schoolType" placeholder="请选择" @change="handleFilter()">
                            <el-option :value="0" label="全部学校类型"></el-option>
                            <el-option :value="1" label="幼儿园"></el-option>
                            <el-option :value="2" label="小学"></el-option>
                            <el-option :value="3" label="初中"></el-option>
                            <el-option :value="4" label="高中"></el-option>
                            <el-option :value="7" label="大中专"></el-option>
                            <el-option :value="10" label="特殊教育"></el-option>
                        </el-select>
               <a :href="downLoadHref"  target="_blank" download="导出">
                    <el-button type="primary" size="medium">导出</el-button>
                </a>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入学校名称/id" v-model.trim="listQuery.searchTitle" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>	
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" >
             <el-table-column  label="id" show-overflow-tooltip  >
                <template slot-scope="scope">
                   {{scope.row.schoolId}}                
                </template>
            </el-table-column> 
             <el-table-column  label="学校名称" show-overflow-tooltip  >
                <template slot-scope="scope">
                    <span class="link-type" @click="resourceusageinfo(scope.row)"> {{scope.row.schoolName}}</span>                   
                </template>
            </el-table-column>  
             <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.schoolType==1">幼儿园</span>
                    <span v-if="scope.row.schoolType==2">小学</span>
                    <span v-if="scope.row.schoolType==3">初中</span>
                    <span v-if="scope.row.schoolType==4">高中</span>
                    <span v-if="scope.row.schoolType==7">大中专</span>
                    <span v-if="scope.row.schoolType==10">特殊教育</span>
                </template>
            </el-table-column> 
            <el-table-column label="区域" align="center">
                <template slot-scope="scope">
                        {{scope.row.orgAreaName}}
                </template>
            </el-table-column>   
            <el-table-column label="限额（GB）" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.limitSize/(1024*1024*1024)}}
                </template>
            </el-table-column> 
             <el-table-column label="已使用（GB）" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{parseFloat(scope.row.userSize/(1024*1024*1024)).toFixed(2)}}
                </template>
            </el-table-column> 
             <el-table-column label="使用率" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <span :class="{'red':parseFloat((scope.row.userSize*100)/scope.row.limitSize).toFixed(2)>80}">
                        {{parseFloat((scope.row.userSize*100)/scope.row.limitSize).toFixed(2)}}%
                    </span>                     
                </template>
            </el-table-column> 
             <el-table-column label="更新时间" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.updateTime.split('.')[0]}}
                </template>
            </el-table-column> 
              <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="updateWxfileInfoSchool(scope.row.schoolId)"  type="text" size="small">更新</el-button>
                         <el-button  @click.native.prevent="dialogVisiblefun(scope.row)"  type="text" size="small">设置限额</el-button>
                     </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
           <el-dialog title="设置限额" :visible.sync="dialogVisible" size="tiny"  width="400px" >
                <div class="input">
                   限额（GB） &nbsp;&nbsp;&nbsp; <el-input-number v-model="limitSize" :precision="0" :step="1" :min="1" :max="10000" placeholder="请输入限额" ></el-input-number>
                </div>
                <span  slot="footer"  class="dialog-footer"   >
                    <el-button  @click="dialogVisible=false">取 消</el-button>
                    <el-button  type="primary" @click="updateWxfileInfoSchools()" >确 定</el-button>
                </span>
             </el-dialog>
    </div>
</template>
<script>
    import {updateWxfileInfoSchool,getWxfileInfoSchoolList} from '@/api/resourceusage';
    import LocationSelector from '@/components/LocationSelector';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    searchTitle: '',
                    areaCode:"",
                    schoolType:0
                },
                dataList: [],
                total: null,
                locationArray: ['320000', '320100', '0'],  
                dialogVisible:false,
                limitSize:100,
                downLoadHref: "",
                schoolId:""
            }
        },
        components: {LocationSelector},
        created() {
            this.getWxfileInfoSchoolList();
            
        },
        mixins: [mixin],       
        methods: {   
             updateWxfileInfoSchool(schoolId) {
                this.$confirm('是否确认要更新？', '更新', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateWxfileInfoSchool({
                      updateType:2,
                      schoolId:schoolId
                    })
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    message: '更新成功',
                                    type: 'success'
                                });
                                this.getWxfileInfoSchoolList();
                            }
                        })
                });
            },
            dialogVisiblefun(obj){
              this.limitSize=parseFloat(obj.limitSize/(1024*1024*1024)).toFixed(2);
              this.schoolId=obj.schoolId;
              this.dialogVisible=true;
            },
            updateWxfileInfoSchools(){
                let myobj={
                   schoolId:this.schoolId,
                   limitSize:this.limitSize*1024*1024*1024,
                   updateType:1
               }
                   updateWxfileInfoSchool(myobj).then(res => {
                        this.$message({
                            type: 'success',
                            message: '设置限额成功!'
                        });
                        this.getWxfileInfoSchoolList();
                        this.dialogVisible=false;
                    }).catch();
            },
           
            //获取列表          
            getWxfileInfoSchoolList() {
                 setTimeout(() => {
                    if(this.locationArray[2]=='0'){
                       this.listQuery.areaCode=this.locationArray[1].slice(0,4)
                    }else{
                       this.listQuery.areaCode=this.locationArray[2]
                    }     
                    this.downLoadHref= global.BasePath+"structure/wxfileInfo/exportWxfileInfoSchoolList?areaCode="+ 
                    this.listQuery.areaCode +
                    "&schoolType=" +
                    this.listQuery.schoolType +
                    "&token=" +
                    this.$store.getters.token;         
                    getWxfileInfoSchoolList(this.listQuery)
                        .then(res => res.data)
                        .then(data => {
                            this.dataList = data.data.dataList;
                            this.total = data.data.pagination.total;
                        }).catch(err => {
                    })
                }, 100);
               
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.getWxfileInfoSchoolList();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.getWxfileInfoSchoolList();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.getWxfileInfoSchoolList();
            },
            //学校
            resourceusageinfo(obj){
                this.$router.push({
                    path: "resourceusageinfo",
                    query:{
                        schoolId:obj.schoolId,
                        name:obj.schoolName
                    }
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
.shortmessageindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
    .red{
        color:#F56C6C;
    }
    .top-box{
        width: 100%;
        height: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/resourceusage/resourceusageindex.vue